export default __webpack_public_path__ + "static/media/qr-code-cox.4888cf89.svg";